// Virtual viewport for our game logic
export const game_width = 347;
export const game_height = 203;
// export const game_width = 256;
// export const game_height = 192;
export const render_width = 256;
export const render_height = 192;
